class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    if (this.notification) {
      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((btn) => btn.addEventListener('click', this.close.bind(this)));
    }
  }

  connectedCallback() {
    // Ascolta l'evento globale di Shopify "cart:updated"
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData && event.cartData.sections) {
        this.renderContents(event.cartData);
      }
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key || (parsedState.items ? parsedState.items[0].key : "");
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      const sectionHtml = parsedState.sections[section.id] || parsedState.sections[section.section];
      if (el && sectionHtml) {
        el.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product', selector: `[id^="cart-notification-product-"]` },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' }
    ];
  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const found = doc.querySelector(selector) || doc.querySelector('.cart-notification-product') || doc.body.firstElementChild;
    return found ? found.innerHTML : doc.body.innerHTML;
  }

  handleBodyClick(evt) {
    if (evt.target !== this.notification && !evt.target.closest('cart-notification')) this.close();
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}